export let SortByEnum;

(function (SortByEnum) {
  SortByEnum["createdAt"] = "createdAt";
  SortByEnum["name"] = "name";
  SortByEnum["email"] = "email";
  SortByEnum["id"] = "id";
  SortByEnum["verified"] = "verified";
  SortByEnum["isLocked"] = "isLocked";
  SortByEnum["provider"] = "provider";
  SortByEnum["tenantId"] = "tenantId";
})(SortByEnum || (SortByEnum = {}));